import { useCallback } from 'react';
import useAuth from 'src/hooks/useAuth';
import type { EdrModuleId } from 'src/mindtime/constants/edrSubscriptionModules';
import { getEdrModulePreviewState } from 'src/mindtime/pages/security/edr/preview';
import { useSubscriptionPermissionsContext } from 'src/mindtime/contexts/SubscriptionPermissionsContext';
import {
  resolveEdrPermissionsReady,
} from 'src/mindtime/utils/subscriptionPermissions';
import { useIsResellerOrg } from 'src/mindtime/hooks/useIsResellerOrg';
import { useEdrModuleAccess } from './useEdrModuleAccess';

/** Subscription gate for EDR data hooks — wait until resolved, then branch on preview. */
export const useEdrDataGate = (moduleId: EdrModuleId) => {
  const access = useEdrModuleAccess();
  const { isInitialized, user } = useAuth();
  const isReseller = useIsResellerOrg();
  const { resolved } = useSubscriptionPermissionsContext();

  const dataReady = resolveEdrPermissionsReady({
    isReseller,
    authInitialized: isInitialized,
    hasAuthUser: Boolean(user),
    subscriptionResolved: resolved,
  });

  const getPreviewState = useCallback(
    () => getEdrModulePreviewState(moduleId),
    [moduleId],
  );

  return {
    ...access,
    skipLive: !dataReady || access.isPreviewMode,
    wait: !dataReady,
    getPreviewState,
  };
};
